import {BettingSvc} from '../services/betting.service';
import {GatewaySvc} from '../services/gateway.service';
import {TranslationSvc} from '../services/translation.service';

/**
 * Future bet validator
 * @module directives/future bet validator
 * @param  {string} value - input value
 * @return {string} original value
 */

export const FutureBetValidator = {
    update(element, binding){
        const maxFutureRounds = BettingSvc.getBettingSvc().maxFutureRounds;


        if (/[\d\.]+/i.test(element.value)) {

            let newValue = parseInt(element.value, 10);

            if(newValue > maxFutureRounds || newValue < 1){
                newValue = 1;
                BettingSvc.getBettingSvc().numEvents = 1;
                GatewaySvc.getGatewaySvc().showDialog({
                    message: TranslationSvc.getTranslation('max_future_rounds', maxFutureRounds),
                    type: 'warning',
                });
                element.focus();
                element.select();
            }

            element.value = newValue;
            binding.value = element.value;

        }else {

            BettingSvc.getBettingSvc().numEvents = 1;
            element.value = 1;
            element.focus();
            element.select();

        }
    },
};


// WEBPACK FOOTER //
// futurebet_validator.js